export default __webpack_public_path__ + "static/media/mysabay.83e6996b.png";